if (!customElements.get("discount-remove")) {
  customElements.define(
    "discount-remove",
    class DiscountRemove extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector("button");
        if (!this.button) return;
        this.button.setAttribute("type", "button");
        this.button.addEventListener("click", this.onRemove.bind(this));
      }

      async onRemove() {
        this.button.classList.add("loading");
        const target = (this.dataset.code || "").trim().toLowerCase();
        const remaining = Array.from(
          new Set(
            Array.from(document.querySelectorAll("discount-remove[data-code]"))
              .map((el) => (el.dataset.code || "").trim())
              .filter((code) => code && code.toLowerCase() !== target)
          )
        );

        const sections = [];
        if (document.getElementById("mini-cart-drawer")) {
          sections.push("mini-cart-drawer");
        }
        const cartItemsEl = document.querySelector("cart-items");
        if (cartItemsEl && typeof cartItemsEl.getSectionsToRender === "function") {
          cartItemsEl.getSectionsToRender().forEach((s) => sections.push(s.section));
        }

        try {
          const body = JSON.stringify({
            discount: remaining.join(","),
            sections,
            sections_url: window.location.pathname,
          });
          const response = await fetch(`${routes.cart_update_url}`, {
            ...fetchConfig(),
            ...{ body },
          });
          const cart = await response.json();
          this.renderSurfaces(cart);
        } catch (error) {
          console.error(error);
          this.button.classList.remove("loading");
        }
      }

      renderSurfaces(cart) {
        if (!cart || !cart.sections) return;
        const drawer = document.getElementById("mini-cart-drawer");
        if (drawer && cart.sections["mini-cart-drawer"]) {
          const html = new DOMParser()
            .parseFromString(cart.sections["mini-cart-drawer"], "text/html")
            .querySelector(".shopify-section");
          if (html) drawer.innerHTML = html.innerHTML;
        }
        const cartItemsEl = document.querySelector("cart-items");
        if (cartItemsEl && typeof cartItemsEl.renderContents === "function") {
          cartItemsEl.renderContents(cart);
        }
      }
    }
  );
}
